import {IEventsGroupedByDay} from '../types';

export const MOCK_EVENTS_GROUPED_BY_DAY: IEventsGroupedByDay[] = [
    {
        date: '2024-03-20',
        events: [
            {
                id: 1,
                title: '',
                type: '',
                eventDate: '2024-03-20',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
            {
                id: 2,
                title: '',
                type: '',
                eventDate: '2024-03-20',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
            {
                id: 3,
                title: '',
                type: '',
                eventDate: '2024-03-20',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
        ],
    },
    {
        date: '2024-03-21',
        events: [
            {
                id: 4,
                title: '',
                type: '',
                eventDate: '2024-03-21',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
            {
                id: 5,
                title: '',
                type: '',
                eventDate: '2024-03-21',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
            {
                id: 6,
                title: '',
                type: '',
                eventDate: '2024-03-21',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
        ],
    },
    {
        date: '2024-03-22',
        events: [
            {
                id: 3,
                title: '',
                type: '',
                eventDate: '2024-03-22',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
        ],
    },
    {
        date: '2024-03-23',
        events: [
            {
                id: 4,
                title: '',
                type: '',
                eventDate: '2024-03-23',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
        ],
    },
    {
        date: '2024-03-24',
        events: [
            {
                id: 5,
                title: '',
                type: '',
                eventDate: '2024-03-24',
                eventTimeBegin: '',
                eventTimeEnd: '',
                address: '',
                price: 0,
                previewImage: {
                    title: '',
                    url: '',
                },
                drinkType: null,
                winery: {
                    code: '',
                    title: '',
                    hasDegustationHall: false,
                },
                tastingCategory: {
                    code: '',
                    title: '',
                },
                url: '',
            },
        ],
    },
];
